import { request } from '@/service/request';

/** 管理后台用户登录 */
export function login(data: Entity.Auth.LoginVo) {
  return request<Entity.Auth.LoginDto>({
    data,
    method: 'post',
    url: '/login'
  });
}

/** 管理后台用户退出 */
export function logout() {
  return request({
    method: 'post',
    url: '/logout'
  });
}

/** 刷新访问令牌 */
export function refreshToken() {
  return request<Entity.Auth.LoginDto>({
    method: 'post',
    url: '/refresh'
  });
}

/** 发送邮箱验证码 */
export function sendEmailCode(data: Entity.Auth.SendEmailCodeVo) {
  return request({
    data,
    method: 'post',
    url: '/login/email/send-code'
  });
}
/** 获取角色菜单列表 */
export function getRoleMenus() {
  return request<Entity.Auth.RoleMenusDto>({
    method: 'get',
    url: '/role-menus'
  });
}
// 发送(确认操作)邮箱验证码
export function sendVerifyCode() {
  return request({
    method: 'post',
    url: '/send-verify-code'
  });
}
